import { render, staticRenderFns } from "./service-common.vue?vue&type=template&id=3f7b17b2&"
import script from "./service-common.vue?vue&type=script&lang=js&"
export * from "./service-common.vue?vue&type=script&lang=js&"
import style0 from "./service-common.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports